import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../components/ui/Button';
import { PageHeader } from '../components/layout/PageHeader';
import { SampleNotice } from '../components/feedback/SampleNotice';
import { SAMPLE_SETTING_GROUPS } from '../features/settings/sampleSettings';
import { formatCount } from '../utils/format';
import '../components/ui/ui.css';
import './pages.css';

/**
 * Platform settings preview. No admin settings endpoint exists yet, so the
 * controls show the intended shape, are disabled, and sit under `SampleNotice`.
 */
export function Settings() {
  const { t } = useTranslation('admin');

  return (
    <div className="page">
      <PageHeader
        title={t('settings.title')}
        subtitle={t('settings.subtitle')}
        actions={
          <Button small disabled>
            {t('settings.save')}
          </Button>
        }
      />

      <SampleNotice />

      <div className="settings-grid">
        {SAMPLE_SETTING_GROUPS.map(group => (
          <section className="page__card" key={group.titleKey}>
            <h2 className="page__section-title">{t(`settings.groups.${group.titleKey}`)}</h2>
            <ul className="settings-list">
              {group.items.map(item => (
                <li className="settings-list__item" key={item.key}>
                  <div className="settings-list__text">
                    <span className="settings-list__label">
                      {t(`settings.items.${item.labelKey}`)}
                    </span>
                    {item.hintKey ? (
                      <span className="settings-list__hint">
                        {t(`settings.items.${item.hintKey}`)}
                      </span>
                    ) : null}
                  </div>
                  {item.kind === 'toggle' ? (
                    <span
                      className={`settings-list__pill${
                        item.enabled ? ' settings-list__pill--on' : ''
                      }`}>
                      {item.enabled ? t('common.yes') : t('common.no')}
                    </span>
                  ) : (
                    <span className="settings-list__pill">
                      {formatCount(item.amount)}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>

      <p className="page__note">{t('settings.disabledHint')}</p>
    </div>
  );
}
